module.exports = __webpack_public_path__ + "img/btn_messege.ce089b62.svg";